import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Grid,
  IconButton,
  SxProps,
  Theme,
  Tooltip,
  styled,
} from "@mui/material";
import { JSX } from "react";
import { Typography } from "@platform/design-system";

type Props = {
  carriers: string[];
  onDelete: (carrier: string) => void;
  containerSx?: SxProps;
};

function SelectedCarriers({
  carriers,
  onDelete,
  containerSx,
}: Props): JSX.Element {
  return (
    <Grid container sx={containerSx}>
      {carriers.length > 0 ? (
        carriers.map((carrier) => (
          <Chip key={carrier}>
            <Tooltip title={carrier}>
              <Box display="flex" alignItems="center">
                <Typography noWrap>{carrier}</Typography>
                <IconButton onClick={() => onDelete(carrier)}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Tooltip>
          </Chip>
        ))
      ) : (
        <Typography>
          <em>No Carriers added</em>
        </Typography>
      )}
    </Grid>
  );
}

export const Chip = styled(Grid)(({ theme }: { theme: Theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingX: 1,
  svg: {
    color: theme.palette.brandSupporting.medium,
  },
}));

export default SelectedCarriers;
